import React, { useEffect, useRef, useState } from 'react'
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";

import './index.scss'

const Analysis = (props: any) => {
    const analysis = [
        {
            type: 'Goals',
            options: props.game.analysis?.filter((a) => a.value === 'total_goals').map((item: any) => ({
                type: item.name,
                home: item.home,
                homePercentage: (item.home / (item.home + item.away) * 100).toFixed(2),
                away: item.away,
                awayPercentage: (item.away / (item.home + item.away) * 100).toFixed(2)
            })),
            bets: props.game.analysis
                ?.filter((a) => a.value === 'total_goals')
                .flatMap((item: any) => item.odds)
                .filter(odds => odds && typeof odds === 'object')
        }, {
            type: 'Corners',
            options: props.game.analysis?.filter((a) => a.value === 'Corner kicks').map((item: any) => ({
                type: item.name,
                home: item.home,
                homePercentage: (item.home / (item.home + item.away) * 100).toFixed(2),
                away: item.away,
                awayPercentage: (item.away / (item.home + item.away) * 100).toFixed(2)
            })),
            bets: props.game.analysis
                ?.filter((a) => a.value === 'Corner kicks')
                .flatMap((item: any) => item.odds)
                .filter(odds => odds && typeof odds === 'object')
        }, {
            type: 'Yellow Cards',
            options: props.game.analysis?.filter((a) => a.value === 'Yellow cards').map((item: any) => ({
                type: item.name,
                home: item.home,
                homePercentage: (item.home / (item.home + item.away) * 100).toFixed(2),
                away: item.away,
                awayPercentage: (item.away / (item.home + item.away) * 100).toFixed(2)
            })),
            bets: props.game.analysis
                ?.filter((a) => a.value === 'Yellow cards')
                .flatMap((item: any) => item.odds)
                .filter(odds => odds && typeof odds === 'object')
        }
    ]

    return (
        <div className='game-analysis-wrapper'>
            <div className="section">
                {
                    analysis.map((item, index) => (
                        <div className="type-wrapper" key={index}>
                            <div className="name">
                                {
                                    item.type === 'Goals' && <SportsSoccerIcon/>
                                }
                                {
                                    item.type === 'Corners' &&
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation"
                                         focusable="false" className="kz-icon-xxs icon--color-white-snow"
                                         fill="var(--momentum-color)"
                                    >
                                        <path
                                            d="M18 7.136L10.615 4v14.4H8.77v-1.384C7.117 17.296 6 17.808 6 18.4c0 .88 2.483 1.6 5.538 1.6 3.056 0 5.539-.72 5.539-1.6 0-.792-1.994-1.448-4.615-1.576v-7.24L18 7.136z"></path>
                                    </svg>
                                }
                                {
                                    item.type === 'Yellow Cards' &&
                                    <svg
                                        className="sr-momentum__event-icon  srt-fill-soccer-yellow-card"
                                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 24"
                                        style={{width: '10px', height: '12px'}}
                                    >
                                        <path
                                            d="M2 0h12c1 0 2 1 2 2v20c0 1-1 2-2 2H2c-1 0-2-1-2-2V2c0-1 1-2 2-2z"></path>
                                    </svg>
                                }
                                {item.type}
                            </div>
                            <div className="options">
                                {
                                    item.options?.map((option, index) => (
                                        <div className="option" key={index}>
                                            <div className="option-name">{option.type}</div>
                                            <div className="value-wrapper">
                                                <div className="home"
                                                     style={{width: `${option.homePercentage}%`}}>
                                                    <span>{option.home}</span></div>
                                                <div className="away"
                                                     style={{width: `${option.awayPercentage}%`}}>{option.away}</div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>

                            {
                                item.bets?.length > 0 &&
                                <div className="suggestions">
                                    <div className="type">
                                        <div className="text">
                                            Great opportunities for this game
                                        </div>
                                    </div>
                                    <div className="bets">
                                        {
                                            item.bets.map((bet: any, index: number) => (
                                                <div className="bet" key={index}>
                                                    <div className="bet-option"> {bet.choiceName} {bet.choiceGroup} FT
                                                    </div>
                                                    <div className="bet-value">{bet.valueDecimal}</div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    ))
                }
            </div>

        </div>
    );
};

export default Analysis
